<template>
  <div>
    <main>
      <DialogErrori ref="dialogerrore"></DialogErrori>

      <section id="head-section">

        <div class="container">
          <div class="row">
            <div class="col-12 col-lg-12">

              <div class="card-wrapper">
                <div class="card">
                  <div class="card-body">
                    <h3 class="card-title">Elenco Mappe Tematiche e Foto dei Villaggi</h3>
                    <v-sheet color="lighten-4" class="pa-3">
                      <v-skeleton-loader class="mx-auto" type="table" v-if="isLoading==true" height="1050">
                      </v-skeleton-loader>
                    </v-sheet>
                    <div class="form-group">
                      <div class="input-group">
                        <div class="input-group-prepend">
                          <div class="input-group-text">
                            <svg class="icon icon-sm">
                              <use :xlink:href="site.baseurl+'/dist/svg/sprite.svg#it-search'"></use>
                            </svg></div>
                        </div>
                        <input type="text" class="form-control" placeholder="Cerca tra i Documenti Digitali"
                          @input="onchangeInputRicerca" v-model="inputRicerca">
                        <div class="input-group-append">
                          <button class="btn btn-info btn-xs btn-icon" v-on:click="resetRicerca">
                            <svg class="icon">
                              <use :xlink:href="site.baseurl+'/dist/svg/sprite.svg#it-refresh'"></use>
                            </svg>
                            <span>Annulla</span>
                          </button>
                        </div>
                      </div>
                    </div>
                    <vue-good-table ref="gridFarConoscere" v-if="isLoading==false" :columns="columnsTableFarConoscere"
                      :rows="rowsTableFarConoscere" compactMode :pagination-options="{
                enabled: true,
                mode: 'records',
                position: 'bottom',
                perPage: this.vgt_perpage,
                perPageDropdown: [10, 50, 100, 1000],
                dropdownAllowAll: true,
                setCurrentPage: this.vgt_setcurrentpage,
                nextLabel: '',
                prevLabel: '',
                rowsPerPageLabel: 'Righe per pagina',
                ofLabel: 'of',
                pageLabel: 'Pagina',
                allLabel: '[Tutte]',
              }" @on-row-click="onClickRowTable" @on-page-change="onPageChange" @on-per-page-change="onPerPageChange">
                      <div slot="emptystate" class="text-center">
                        Nessun risultato
                      </div>
                    </vue-good-table>
                  </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </section>

    </main>
  </div>
</template>

<script>
/* eslint-disable */
  // @ is an alias to /src
  import APIFarConoscereVDA from '@/services/api/FarConoscereVda.js'
  import JSDataGridRow from '@/static/js/Datagridrow.js'
  import Common from '@/static/js/Common.js'
  //dialog errori
  import DialogErrori from '../common/DialogErrori.vue';
  import {
    VueGoodTable,
  } from 'vue-good-table';

  import 'vue-good-table/dist/vue-good-table.css'
  export default {
    name: 'Datagrid',
    data() {
      return {
        site: {
          baseurl: process.env.VUE_APP_BOOTSTRAP_ITALIA_PATH,
        },
        //icon: 'far fa-list-alt',
        //placeholderCerca: 'Inserisci parte della colonna applicazione',
        //prefixCerca: 'Applicazioni:',
        //grid
        vgt_perpage: 10,
        vgt_setcurrentpage: 1,
        columnsTableFarConoscere: APIFarConoscereVDA.getColsFarConoscere(this),
        rowsTableFarConoscere: [],
        rowsTableFarConoscereOrig: [],
        //errori
        error: '',
        //loader
        //isLoading: true,
        isLoading: false,
        //informazioni di dettaglio
        keyDetail: 'identifier',
        nameDetail: 'SchedaDettaglio',
        formDetail: 'schede/scheda_dettaglio',
        inputRicerca: ''
      }
    },
    components: {
      VueGoodTable,
      // Cards,
      DialogErrori,
    },
    methods: {
      onPageChange(params) {
        this.vgt_setcurrentpage = params.currentPage
        this.$store.commit('setVgtSetcurrentPage', this.vgt_setcurrentpage)
      },
      onPerPageChange(params) {
        this.vgt_perpage = params.currentPerPage
        this.$store.commit('setVgtPerPage', this.vgt_perpage)
      },
      resetRicerca() {
        this.vgt_setcurrentpage = 1
        this.$store.commit('setVgtSetcurrentPage', this.vgt_setcurrentpage)
        this.vgt_perpage = 10
        this.$store.commit('setVgtPerPage', this.vgt_perpage)
        this.inputRicerca=''
        this.$store.commit('setInputRicerca', this.inputRicerca)
        this.onchangeInputRicerca()
      },
      //ricerca manuale
      onchangeInputRicerca() {
        let sep = ' '
        let tmp = []
        let bool_i;
        this.rowsTableFarConoscere = this.rowsTableFarConoscereOrig
        this.$store.commit('setInputRicerca', this.inputRicerca)
        if (this.inputRicerca != '') {
          let inputRicerca = this.inputRicerca.split(sep)
          for (let i = 0; i < this.rowsTableFarConoscereOrig.length; i++) {
            bool_i = true
            for (let k = 0; k < inputRicerca.length; k++) {
              if (inputRicerca[k] != '') {
                let k_ricerca =  inputRicerca[k].normalize("NFD").replace(/\p{Diacritic}/gu, "") 
                let title=this.rowsTableFarConoscereOrig[i].title
                if(!title){
                  title=''
                }
                let description=this.rowsTableFarConoscereOrig[i].description
                if(!description){
                  description=''
                }
                let record_type=this.rowsTableFarConoscereOrig[i].record_type
                if(!record_type){
                  record_type=''
                }
                let identifier=this.rowsTableFarConoscereOrig[i].identifier
                if(!identifier){
                  identifier=''
                }
                let record_date=this.rowsTableFarConoscereOrig[i].record_date
                if(!record_date){
                  record_date=''
                }
                let creator=this.rowsTableFarConoscereOrig[i].creator
                if(!creator){
                  creator=''
                }
                let re = new RegExp(k_ricerca, 'i');
                if (
                    title.normalize("NFD").replace(/\p{Diacritic}/gu, "").search(re) >= 0 ||
                    description.normalize("NFD").replace(/\p{Diacritic}/gu, "").search(re) >= 0 ||
                    record_type.normalize("NFD").replace(/\p{Diacritic}/gu, "").search(re) >= 0 ||
                    identifier.normalize("NFD").replace(/\p{Diacritic}/gu, "").search(re) >= 0 ||
                    record_date.normalize("NFD").replace(/\p{Diacritic}/gu, "").search(re) >= 0 ||
                    creator.normalize("NFD").replace(/\p{Diacritic}/gu, "").search(re) >= 0
                ) {
                  bool_i = bool_i && true
                } else {
                  bool_i = bool_i && false
                }
              }
            }
            if (bool_i) {
              tmp.push(this.rowsTableFarConoscereOrig[i])
            }
          }
          this.rowsTableFarConoscere = tmp
        }
      },
      openDetail(row) {

        // var name = this.nameDetail,
        // var path = this.formDetail, 
        // var params = {
        // var id = row[this.keyDetail].split('/')[row[this.keyDetail].split('/').length - 1]
                
        // var url = "FarConoscereVDA/schede/scheda_dettaglio/pagina-016-corniola2-us2"
        // window.open("FarConoscereVDA/schede/scheda_dettaglio/pagina-016-corniola2-us2")

        var newRoute = this.$router.resolve({
          name: this.nameDetail,
          path: this.formDetail,
          params: {
            id: row[this.keyDetail].split('/')[row[this.keyDetail].split('/').length - 1]
          }
        })

        window.open(newRoute.href)

        // this.$router.push({
        //   name: this.nameDetail,
        //   path: this.formDetail,
        //   params: {
        //     id: row[this.keyDetail].split('/')[row[this.keyDetail].split('/').length - 1]
        //   }
        // })
      },
      onClickRowTable(params) {
        // console.log('row:', params.row)
        this.openDetail(params.row)
      },
    },
    beforeMount() {
      this.inputRicerca = this.$store.getters.inputRicerca
      JSDataGridRow.resetStoreVar(this.$store, 'setRecordheaderContext')
      //inizializzo vue-good-table
      this.vgt_perpage = this.$store.getters.vgtPerPage
      this.vgt_setcurrentpage = this.$store.getters.vgtSetcurrentPage
      this.isLoading = true
      var obj = this;
      //Salvo path corrente per gestione del back
      // this.$store.commit('setUrlBack', this.$router.currentRoute.fullPath)
      // this.settaParamsRicercaDefault()
      //Popolo grid sorgente dati
      APIFarConoscereVDA.getRowsFarConoscere()
        .then(rowsTableFarConoscere => {
          this.rowsTableFarConoscere = rowsTableFarConoscere.data
          this.rowsTableFarConoscereOrig = this.rowsTableFarConoscere
        })
        .catch(function (error) {
          obj.error = error;
        })
        .finally(() => {
          this.isLoading = false
          if (this.error != '') {
            console.error(this.error);
            Common.openDialogErrore(this, 'Operazione fallita', 'getRowsFarConoscere - ' + this.error);
          }
          this.onchangeInputRicerca()
        });
    },
  }

</script>
